export enum ServiceTaskTab {
	Inbox,
	Scheduled
}

export enum ServiceTaskSortColumn {
	Received,
	Scheduled
}
